const LOCAL_PROVIDER_ORIGIN = 'http://provider.localhost:3000'

function isLegacyLocalProviderHost(hostname: string, port: string): boolean {
  if (hostname === 'provider.localhost') return false
  if (hostname !== 'localhost' && hostname !== '127.0.0.1') return false
  return port === '' || port === '3000' || port === '3001'
}

/**
 * Sign-up Survey copy link: `{provider origin}/instruments/{id}` with no token.
 * Rewrites stale `/s/{slug}` API URLs and local `localhost:3001` hosts.
 */
export function resolveSignupSurveyShareUrl(input: {
  instrumentId: string
  publicSurveyUrl?: string | null
}): string | null {
  const instrumentId = input.instrumentId.trim()
  if (!instrumentId) return null

  const raw = input.publicSurveyUrl?.trim() ?? ''
  if (!raw) {
    return `${LOCAL_PROVIDER_ORIGIN}/instruments/${instrumentId}`
  }

  try {
    const parsed = new URL(raw)
    const origin = isLegacyLocalProviderHost(parsed.hostname, parsed.port)
      ? LOCAL_PROVIDER_ORIGIN
      : parsed.origin.replace(/\/$/, '')
    return `${origin}/instruments/${instrumentId}`
  } catch {
    return `${LOCAL_PROVIDER_ORIGIN}/instruments/${instrumentId}`
  }
}
